import type { AlaparForras, EpuletTipus, IngatlanTipus } from '@ertekbecslo/becslo';

export type Szandek = '3_honapon_belul' | '3_12_honap' | 'erdeklodik';
export type Idosav = 'delelott' | 'delutan' | 'este' | 'barmikor';
/** A jelentés a tulajdonos szemszögéből: `alatta` = az eredmény alacsonyabb a vártnál (többre számított). */
export type Arelvaras = 'alatta' | 'benne' | 'folotte';

export const TIPUS_CIMKE: Record<IngatlanTipus, string> = {
  lakas: 'Lakás', haz: 'Ház', iroda: 'Iroda', ipari: 'Ipari ingatlan', telek: 'Telek', garazs: 'Garázs',
};

export const TIPUS_CIMSOR: Record<IngatlanTipus, string> = {
  lakas: 'Mennyit ér a lakása?', haz: 'Mennyit ér a háza?', iroda: 'Mennyit ér az irodája?',
  ipari: 'Mennyit ér az ipari ingatlana?', telek: 'Mennyit ér a telke?', garazs: 'Mennyit ér a garázsa?',
};

export const EPULET_CIMKE: Record<EpuletTipus, string> = { tegla: 'Tégla', panel: 'Panel', uj_epitesu: 'Új építésű' };

export const JELLEMZO_KERDES: Record<string, string> = {
  allapot: 'Milyen állapotú?',
  emelet: 'Hányadik emeleten van?',
  erkely: 'Van erkélye?',
  parkolas: 'Hol lehet parkolni?',
  kategoria: 'Milyen kategóriájú?',
  belterulet: 'Belterületen van?',
  kozmu: 'Milyen közművek vannak?',
  fajta: 'Milyen garázs?',
  energetika: 'Milyen az energetikai besorolása?',
  falazat: 'Miből épült a ház fala?',
};

/** Kulcs: `<jellemző>.<érték>`, mert ugyanaz az érték típusonként mást jelenthet (pl. `parkolas.beallo`, `fajta.beallo`). */
export const ERTEK_CIMKE: Record<string, string> = {
  'allapot.uj_szeru': 'Újszerű',
  'allapot.felujitott': 'Felújított',
  'allapot.reszben_felujitott': 'Részben felújított',
  'allapot.atlagos': 'Átlagos',
  'allapot.felujitando': 'Felújítandó',
  'allapot.bontando': 'Bontandó',
  'emelet.foldszint': 'Földszint',
  'emelet.1_2': '1–2. emelet',
  'emelet.3_felett_lifttel': '3. emelet felett, lifttel',
  'emelet.3_felett_lift_nelkul': '3. emelet felett, lift nélkül',
  'erkely.van': 'Van',
  'erkely.nincs': 'Nincs',
  'parkolas.sajat': 'Saját beálló vagy garázs',
  'parkolas.utcai': 'Utcán',
  'parkolas.garazs': 'Garázs',
  'parkolas.beallo': 'Beálló',
  'parkolas.nincs': 'Nincs',
  'kategoria.A': 'A kategória',
  'kategoria.B': 'B kategória',
  'kategoria.C': 'C kategória',
  'kategoria.nem_tudom': 'Nem tudom',
  'kategoria.raktar': 'Raktár',
  'kategoria.csarnok': 'Csarnok',
  'kategoria.muhely': 'Műhely',
  'belterulet.igen': 'Igen',
  'belterulet.nem': 'Nem, külterület',
  'belterulet.nem_tudom': 'Nem tudom',
  'kozmu.teljes': 'Teljes közmű',
  'kozmu.reszleges': 'Részleges',
  'kozmu.nincs': 'Nincs közmű',
  'fajta.beallo': 'Beálló (teremgarázsban)',
  'fajta.onallo': 'Önálló garázs',
  'energetika.korszeru': 'Korszerű (AA–BB)',
  'energetika.atlagos': 'Átlagos (CC–EE)',
  'energetika.korszerutlen': 'Korszerűtlen (FF–JJ)',
  'energetika.nem_tudom': 'Nem tudom',
  'falazat.tegla_blokk': 'Tégla vagy blokk',
  'falazat.valyog': 'Vályog',
  'falazat.konnyuszerkezet': 'Könnyűszerkezet',
  'falazat.egyeb': 'Egyéb',
};

export const SZANDEK_CIMKE: Record<Szandek, string> = {
  '3_honapon_belul': '3 hónapon belül',
  '3_12_honap': '3–12 hónapon belül',
  erdeklodik: 'Csak érdeklődöm',
};

export const IDOSAV_CIMKE: Record<Idosav, string> = { delelott: 'Délelőtt', delutan: 'Délután', este: 'Este', barmikor: 'Bármikor' };
export const IDOSAV_KOSZONO: Record<Idosav, string> = { delelott: 'délelőtt', delutan: 'délután', este: 'este', barmikor: 'bármikor' };

export const ARELVARAS_CIMKE: Record<Arelvaras, string> = {
  alatta: 'Többre számítottam', benne: 'Kb. erre', folotte: 'Kevesebbre számítottam',
};
/** Válasz után a látogatónak szóló rövid, meleg visszajelzés. */
export const ARELVARAS_VISSZAJELZES: Record<Arelvaras, string> = {
  alatta: 'Köszönjük! A helyszíni szemlén kollégánk megnézi, mi indokolhat magasabb árat.',
  benne: 'Köszönjük! Örülünk, hogy az eredmény egybevág az elképzelésével.',
  folotte: 'Köszönjük! Jó hír, hogy az ingatlan értékesebb, mint gondolta.',
};
export const ARELVARAS_NEUTRALIS = 'Köszönjük, ezt már rögzítettük.';

export const INDOKLAS: Record<AlaparForras, string> = {
  ksh_utca: 'Az utca KSH által közzétett adásvételi adatai és az MNB-lakásárindex alapján.',
  ksh_terulet: 'A környék KSH által közzétett adásvételi adatai és az MNB-lakásárindex alapján.',
  iroda: 'Az iroda helyi piaci adatai alapján.',
};
